import { FC } from 'react';

import { ContentfulAccordionsSection } from 'src/data/Contentful/ContentfulTypes';
import { RichTextContentful } from 'src/general/components/RichTextContentful/RichTextContentful';
import { AccordionSection } from 'src/general/sections/AccordionSection/AccordionSection';
import { SectionProps } from 'src/hygiene/sections/SectionManager/types';

import { FaqJsonLD } from './FaqJsonLD';

interface Props
  extends SectionProps<
    ContentfulAccordionsSection,
    'title' | 'firstAccordionOpen' | 'faqsCollection' | 'ctaButtonText' | 'ctaButtonLink'
  > {}

export const ContentfulRichTextAccordionSection: FC<Props> = ({
  sectionData: { title, ctaButtonLink, ctaButtonText, faqsCollection },
}) => (
  <>
    <FaqJsonLD faqs={faqsCollection} />
    <AccordionSection
      title={title}
      items={faqsCollection.items.map((item) => ({
        id: item.sys.id,
        header: item.question,
        content: <RichTextContentful>{item.answer}</RichTextContentful>,
      }))}
      trackingName={title}
      cta={
        ctaButtonLink && ctaButtonText
          ? {
              href: ctaButtonLink,
              label: ctaButtonText,
              size: 'medium',
            }
          : undefined
      }
    />
  </>
);
